import { render, staticRenderFns } from "./jinchu-lunbo.vue?vue&type=template&id=0518d408&"
import script from "./jinchu-lunbo.vue?vue&type=script&lang=js&"
export * from "./jinchu-lunbo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports